import * as messageBox from './ui-message-box.js'
import * as buttonSprite from './ui-button-sprite.js'

export default async function procRestack(params) {
    const { app, w, h, cards, splits } = params;

    // Show message
    const text = '3つの山を1つにまとめます\n一番下にしたい山を選んでください';
    let mes = messageBox.gen(app, text);
    mes.y = h * 0.15;
    mes.zIndex = 100;

    // Function stack card
    let count = 0;
    let x = w / 2;
    let y = h * 0.45;
    const stackCard = (range) => {
        let pArr = cards.map((card, i) => {
            if (i < range.start || range.end < i) return;
            card.zIndex = card.__indexSort = count ++;
            y -= 2;
            return anime({targets: card, x, y, easing: 'linear', duration: 500}).finished;
        });
        return pArr;
    };

    // Stack 3 card group
    await new Promise(resolve => {
        const moveEnd = [false, false, false];
        splits.map((range, i) => {
            const card = cards[range.end];
            buttonSprite.onClick(card, async () => {
                // 1st and 2nd
                moveEnd[i] = true;
                buttonSprite.offClick(card);
                await Promise.all(stackCard(range));
                mes.destroy();

                // 1st
                if (moveEnd.filter(x => x).length === 1) {
                    const text = '次の山を選んでください';
                    mes = messageBox.gen(app, text);
                    mes.y = h * 0.15;
                    return;
                }

                // 2nd
                const j = moveEnd.indexOf(false);
                moveEnd[j] = true;
                range = splits[j];
                buttonSprite.offClick(cards[range.end]);
                await Promise.all(stackCard(range));
                cards.sort((a, b) => a.__indexSort - b.__indexSort);
                resolve();
            });
        });
    });
}
